export default class FieldBindingPropKeys {
    public static readonly Orientation = 'LIST:FORMATTING:ORIENTATION';
}
